import AcheivementCard from './AcheivementCard';
import { AcheivementCardLoading } from './AcheivementCardLoading';

export default AcheivementCard;
export { AcheivementCardLoading };
